"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VcfMessageService = exports.MessageAction = exports.MessageCategory = void 0;
const types_1 = require("../shared/types");
var MessageCategory;
(function (MessageCategory) {
    MessageCategory[MessageCategory["REMOTELOCKUNLOCK"] = 1] = "REMOTELOCKUNLOCK";
    MessageCategory[MessageCategory["ANTITHEFTALARM"] = 2] = "ANTITHEFTALARM";
    MessageCategory[MessageCategory["HONKFLASH"] = 3] = "HONKFLASH";
    MessageCategory[MessageCategory["GEOFENCE"] = 4] = "GEOFENCE";
    MessageCategory[MessageCategory["SPEEDALERT"] = 5] = "SPEEDALERT";
    MessageCategory[MessageCategory["DIGITALKEY"] = 6] = "DIGITALKEY";
    MessageCategory[MessageCategory["UNKNOWN"] = 7] = "UNKNOWN";
})(MessageCategory || (exports.MessageCategory = MessageCategory = {}));
var MessageAction;
(function (MessageAction) {
    MessageAction[MessageAction["LOCK"] = 0] = "LOCK";
    MessageAction[MessageAction["UNLOCK"] = 1] = "UNLOCK";
    MessageAction[MessageAction["ALARM_INTERIOR"] = 2] = "ALARM_INTERIOR";
    MessageAction[MessageAction["ALARM_EXTERIOR"] = 3] = "ALARM_EXTERIOR";
    MessageAction[MessageAction["ALARM_MOVEMENT"] = 4] = "ALARM_MOVEMENT";
    MessageAction[MessageAction["ALARM_TRAILER"] = 5] = "ALARM_TRAILER";
    MessageAction[MessageAction["ALARM_UNKNOWN"] = 6] = "ALARM_UNKNOWN";
    MessageAction[MessageAction["HONK"] = 7] = "HONK";
    MessageAction[MessageAction["FLASH"] = 8] = "FLASH";
    MessageAction[MessageAction["HONKFLASH"] = 9] = "HONKFLASH";
    MessageAction[MessageAction["EXIT_GREENZONE"] = 10] = "EXIT_GREENZONE";
    MessageAction[MessageAction["ENTER_REDZONE"] = 11] = "ENTER_REDZONE";
    MessageAction[MessageAction["START_EXCEEDING"] = 12] = "START_EXCEEDING";
    MessageAction[MessageAction["MK_INSTALLED"] = 13] = "MK_INSTALLED";
    MessageAction[MessageAction["PERMISSION_DECLINED"] = 14] = "PERMISSION_DECLINED";
    MessageAction[MessageAction["PERMISSION_GRANTED"] = 15] = "PERMISSION_GRANTED";
    MessageAction[MessageAction["PERMISSION_VTAN_REJECTED"] = 16] = "PERMISSION_VTAN_REJECTED";
    MessageAction[MessageAction["PERMISSION_REVOKED_VERWALTER"] = 17] = "PERMISSION_REVOKED_VERWALTER";
    MessageAction[MessageAction["PERMISSION_AND_MK_REVOKED_VERWALTER"] = 18] = "PERMISSION_AND_MK_REVOKED_VERWALTER";
    MessageAction[MessageAction["PERMISSION_RETURNED"] = 19] = "PERMISSION_RETURNED";
    MessageAction[MessageAction["MK_RETURNED"] = 20] = "MK_RETURNED";
    MessageAction[MessageAction["PERMISSION_EXPIRED"] = 21] = "PERMISSION_EXPIRED";
    MessageAction[MessageAction["PERMISSION_AND_MK_EXPIRED"] = 22] = "PERMISSION_AND_MK_EXPIRED";
    MessageAction[MessageAction["MK_REMOVAL_SUCCEEDED_VERWALTER"] = 23] = "MK_REMOVAL_SUCCEEDED_VERWALTER";
    MessageAction[MessageAction["MK_REMOVAL_FAILED_VERWALTER"] = 24] = "MK_REMOVAL_FAILED_VERWALTER";
    MessageAction[MessageAction["MK_EXTENDED"] = 25] = "MK_EXTENDED";
    MessageAction[MessageAction["UNKNOWN"] = 26] = "UNKNOWN";
})(MessageAction || (exports.MessageAction = MessageAction = {}));
class VcfMessageService {
    constructor(vcfTransactionHistoryClient) {
        this.vcfTransactionHistoryClient = vcfTransactionHistoryClient;
    }
    async getMessages(vin, devicePlatform) {
        var _a, _b;
        const isWcar = devicePlatform === types_1.DevicePlatform.WCAR;
        const transactionHistoryResponse = await this.vcfTransactionHistoryClient.getTransactionHistory(vin, isWcar);
        return this.filterAndTransformAndSort((_b = (_a = transactionHistoryResponse.data) === null || _a === void 0 ? void 0 : _a.messages) !== null && _b !== void 0 ? _b : []);
    }
    async deleteMessage(vin, devicePlatform, category) {
        const validCategories = [MessageCategory.ANTITHEFTALARM, MessageCategory.GEOFENCE, MessageCategory.SPEEDALERT];
        if (validCategories.includes(category)) {
            const isWcar = devicePlatform === types_1.DevicePlatform.WCAR;
            return this.vcfTransactionHistoryClient.deleteTransactionHistory(vin, isWcar, MessageCategory[category].toLowerCase());
        }
    }
    filterAndTransformAndSort(messages) {
        return messages.map(this.transformVcfTransactionHistoryMessageToMessage)
            .filter((entry) => entry.action !== MessageAction.UNKNOWN)
            .sort(this.sortMessagesByTimestamp);
    }
    sortMessagesByTimestamp(message1, message2) {
        const firstDate = message1.timestamp ? new Date(message1.timestamp) : new Date();
        const secondDate = message2.timestamp ? new Date(message2.timestamp) : new Date();
        return secondDate.getTime() - firstDate.getTime();
    }
    transformVcfTransactionHistoryMessageToMessage(message) {
        var _a, _b, _c, _d, _e, _f;
        return {
            category: (_c = MessageCategory[(_b = (_a = message.category) === null || _a === void 0 ? void 0 : _a.toUpperCase()) !== null && _b !== void 0 ? _b : '']) !== null && _c !== void 0 ? _c : MessageCategory.UNKNOWN,
            timestamp: message.timestamp,
            action: (_f = MessageAction[(_e = (_d = message.action) === null || _d === void 0 ? void 0 : _d.toUpperCase()) !== null && _e !== void 0 ? _e : '']) !== null && _f !== void 0 ? _f : MessageAction.UNKNOWN,
            actionSuccess: message.actionSuccess,
            alertName: message.alertName,
            keyName: message.keyName,
            keyUserName: message.keyUserName
        };
    }
}
exports.VcfMessageService = VcfMessageService;
//# sourceMappingURL=VcfMessageService.js.map